import Vue from 'vue' ;
import { Component, Prop } from 'vue-property-decorator' ;
import { TranslateResult } from 'vue-i18n';
import * as countries from 'i18n-iso-countries' ;
import { AddressDto, IAddress } from '../../models/address/address.model';


interface ICountry {
    code?: string
    text?: string
}

@Component
class AddressFields extends Vue {

    @Prop({ type: [Boolean], default: () => false })
    required: boolean;
    @Prop({ type: [Object] })
    value: IAddress;
    @Prop({ type: [Boolean] , default: ()=> true })
    isValidAddressLine: boolean


    readonly googlePlaces: any;
    readonly service: any

    dtRules: {
        addressRules?: any
        codePostalRules?: any
        cityRules?: any
        countryRules?: any
    }

    dtLine_1: string

    constructor(){
        super()

        this.dtRules= {}
        this.dtLine_1= this.value.line1 || ''

        /**
         * @description initialise google maps places tools
         */

        const googleApi= (window as any).google
        if(!googleApi) throw new Error('google api lib doesnt exist')
        this.googlePlaces= googleApi.maps && googleApi.maps.places
        this.service= new this.googlePlaces.AutocompleteService()

    }

    created() {}

    mounted() {
        this.initilializeGooglePlaces()
        this.dtRules= {
            addressRules: [
                v => ( !this.required &&  !this.coIsFieldNotEmpty) || ( !!v || this.$t(this.lblSetting.emptyRequired, {type: this.$t(this.lblSetting.member_form.address) }) ),
                //v => this.isValidAddressLine || this.$t(this.lblSetting.addressValid)
            ],
            codePostalRules: [
                v => ( !this.required && !this.coIsFieldNotEmpty) || ( !!v || this.$t(this.lblSetting.emptyRequired, {type: this.sliceType(this.$t(this.lblSetting.member_form.code_postal)) }) )
            ],
            cityRules: [
                v =>  ( !this.required && !this.coIsFieldNotEmpty) || ( !!v || this.$t(this.lblSetting.emptyRequired, {type: this.sliceType(this.$t(this.lblSetting.member_form.city)) }) )
            ],
            countryRules: [
                v =>  ( !this.required && !this.coIsFieldNotEmpty) || ( !!v || this.$t(this.lblSetting.emptyRequired, {type: this.sliceType(this.$t(this.lblSetting.member_form.country)) }) )
            ]
        }
    }

    get lblSetting(){
        return {
            ...require('@/locales/profile').default,
            ...require('@/locales/validation-messages').default
        }
    }

    get coIsFieldNotEmpty(): boolean {
        return this.value.isNotEmpty()
    }

    get line_1(){
        return this.dtLine_1
    }

    set line_1(value: string){
        this.dtLine_1= value
    }

    get line_2(){
        return this.value.line2
    }

    set line_2(value: string){
        this.$emit('input',new AddressDto({...this.value, line2: value}))
    }

    get postal_code(){
        return this.value.zip_code
    }

    set postal_code(value: string){
        this.$emit('input',new AddressDto({ ...this.value, zip_code: value }))
    }

    get city(){
        return this.value.city
    }

    set city(value: string){
        this.$emit('input',new AddressDto({ ...this.value, city: value }))
    }

    get country(){
        return this.value.country
    }

    set country(value: string){
        this.$emit('input',new AddressDto({ ...this.value, country: value }))
    }

    get address(): IAddress{
        return {}
    }

    set address(payload: IAddress){
        //this.$emit('update:isValidAddressLine',true)
        this.$emit('input',new AddressDto({ ...this.value, ...payload }))
    }

    handleLineBlur(e:Event){
        if(!this.dtLine_1){
            this.$emit('input',new AddressDto({ ...this.value, lat: null, lng: null, line1: '' }))
        }
        else {
            this.$emit('input',new AddressDto({...this.value, line1: this.dtLine_1 }))
        }
    }

    validateAddressLine(address: string,cb: (valid: boolean)=> void) {
        const request= { input: address }
        this.service.getQueryPredictions(request,(predictions,status)=>{
            if(status !== this.googlePlaces.PlacesServiceStatus.OK) return
            if(predictions && predictions.length){
                const firstPrediction= predictions[0]
                if(firstPrediction.description && firstPrediction.description === address) cb(true)
                else cb(false)
            }
            else cb(false)
        })
    }

    sliceType(text: TranslateResult ): string {
        return (text as string).slice(0,(text as string).length-1)
    }

    initilializeGooglePlaces(){
        var defaultBounds = new (window as any).google.maps.LatLngBounds(
                new (window as any).google.maps.LatLng(43.11242, -4.99430),
                new (window as any).google.maps.LatLng(52.832969,7.9455301)
            );


        var options= {
            bounds: defaultBounds,
            types: ['address']
        }

        var cities_options= {
            ...options,
            types: ['(cities)']
        }

        var input_line1: HTMLInputElement = document.querySelector('.address--line__1 input')
        var input_city: HTMLInputElement= document.querySelector('.address--city input')
        var input_country: HTMLInputElement= document.querySelector('.address--country input')
        input_line1.placeholder= ''
        input_city.placeholder= ''
        input_country.placeholder= ''

        input_line1.addEventListener('blur',this.handleLineBlur)

        var autocomplete_line1= new this.googlePlaces.Autocomplete(input_line1,options)
        var autocomplete_city= new this.googlePlaces.Autocomplete(input_city,cities_options)

        autocomplete_line1.addListener('place_changed',e =>{
            const place= autocomplete_line1.getPlace()
            let country: ICountry ,city,zip_code;
            const address_components: any[]= place['address_components'] || []
            address_components.forEach(component=>{
                if(component.types.includes('country')) country= { code: component['short_name'], text: component['long_name'] }
                if(component.types.includes('locality') || component.types.includes('postal_town') ) city= component['long_name']
                if(component.types.includes('postal_code')) zip_code= component['long_name']
            })
            const lat = place.geometry.location.lat()
            const lng= place.geometry.location.lng()

            this.dtLine_1= place.name || this.dtLine_1
            this.address= {
                line1: this.dtLine_1,
                city,
                country: this.getCountry(country) ,
                countryCode: country.code.toLowerCase(),
                lat,
                lng,
                zip_code
            }
        })

        autocomplete_city.addListener('place_changed',e=>{
            const place= autocomplete_city.getPlace()
            const address_components: any[]= place['address_components'] || []
            let country:ICountry;
            address_components.forEach(component=>{
                if(component.types.includes('country')) country={ code: component['short_name']  , text: component['long_name']  }
            })

            this.address= {
                city: place.name || place.vicinity,
                country: this.getCountry(country) ,
                countryCode: country.code.toLowerCase()
            }

            if(country.code) autocomplete_line1.setComponentRestrictions({ country:  country.code.toLowerCase() })
        })
    }

    getAddressLine(country: ICountry, formattedAddress: string){
        const c = this.getCountry(country)
        if(!c) return formattedAddress
        return formattedAddress.replace(country.text,c)
    }

    getCountry(country: ICountry){
        return countries.isValid(country.code) ?
                        countries.getName(country.code,this.$i18n.locale || this.$i18n.fallbackLocale) : (country.text || '')
    }
}

export default AddressFields



// WEBPACK FOOTER //
// ./src/components/address-fields/index.ts